<template>
    <div class="score_chart" ref="chart" style="width:300px;height:180px"></div>
</template>

<script type="text/javascript">
    import echarts from 'echarts'
    export default {
        props: {
            scoreData: {
                type: Object,
                required: true
            },
            refresh: Boolean
        },
        computed: {
            seriesData () {
                return {
                    indicators: [
                        { name: '选股能力', max: 20 },
                        { name: '绝对收益', max: 20 },
                        { name: '盈利能力', max: 20 },
                        { name: '抗风险能力', max: 20 },
                        { name: '稳定性', max: 20 }
                    ],
                    data: [
                        this.scoreData.winRate,
                        this.scoreData.annualYield,
                        this.scoreData.averageLossRatio,
                        this.scoreData.maxDrawDown,
                        this.scoreData.profitVolatility
                    ]
                }
            }
        },
        methods: {
            renderChart () {
                const chartDom = this.$refs.chart
                if (!chartDom) return

                const myChart = echarts.init(chartDom)

                const option = {
                    backgroundColor: 'transparent',
                    tooltip: {
                        trigger: 'item',
                        backgroundColor: 'rgba(48, 63, 159, 0.9)',
                        borderColor: '#303f9f',
                        borderWidth: 1,
                        textStyle: {
                            color: '#fff',
                            fontSize: 12
                        },
                        padding: [6, 10],
                        formatter: function (params) {
                            const {value} = params
                            const indicatorNames = ['选股能力', '绝对收益', '盈利能力', '抗风险能力', '稳定性']
                            let ret = ''
                            for (let idx in value) {
                                ret += indicatorNames[idx] + ': ' + params.value[idx]
                            }
                            return ret
                        }
                    },
                    radar: {
                        indicator: this.seriesData.indicators,
                        shape: 'polygon',
                        splitNumber: 5,
                        radius: '60%'
                    },
                    series: [{
                        type: 'radar',
                        data: [{
                            value: this.seriesData.data,
                            name: '得分',
                            symbol: 'circle',
                            symbolSize: 4,
                            lineStyle: {
                                color: '#303f9f',
                                width: 1
                            },
                            areaStyle: {
                                color: 'rgba(48, 63, 159, 0.1)'
                            },
                            itemStyle: {
                                color: '#303f9f'
                            }
                        }]
                    }]
                }

                myChart.setOption(option)
            },
            _renderError () {

            }
        },
        mounted () {
            this.renderChart()
        },
        watch: {
            refresh () {
                this.renderChart()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/strategybacktest/scoreChart.vue